import { useLocation, matchPath } from "react-router-dom";
import Navbar from "../src/components/Navbar";
import Footer from "../src/components/Footer";
import FloatingAssistant from "./components/ui/FloatingAssistant";


const Layout = ({ children }) => {
  const location = useLocation();

  // 1. Definimos las rutas estáticas
  const staticExcludedRoutes = ["/login", "/registro", "/planos"];

  // 2. Verificamos si es una ruta estática excluida
  const isStaticExcluded = staticExcludedRoutes.includes(location.pathname);

  // 3. Verificamos si la ruta actual coincide con el patrón dinámico de planos
  const isDynamicExcluded = matchPath({ path: "/planos/:id" }, location.pathname);

  // El asistente se muestra solo si NO está en ninguna de las exclusiones
  const showAssistant = !isStaticExcluded && !isDynamicExcluded;

  return (
    <div className="flex flex-col min-h-screen">
      {showAssistant && <FloatingAssistant />}
      <Navbar />
      <main className="flex-grow">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;